const footerSections = [
  {
    id: "fs-1",
    title: "浏览本页",
    links: [
      { label: "系列简介", href: "#intro" },
      { label: "课程目录总览", href: "#catalog" },
      { label: "课程导航", href: "#lessons" },
      { label: "教学视频资源", href: "#videos" },
    ],
  },
  {
    id: "fs-2",
    title: "学习参考",
    links: [
      { label: "学习路径", href: "#path" },
      { label: "系列看点", href: "#highlights" },
      { label: "常见问题", href: "#faq" },
      { label: "观看指南", href: "#guide" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                秘密教学
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80 font-body">
              一个专注整理「秘密教学」系列课程目录与教学视频资源的单页站点。
              从第一课到完整版，把系列结构、集数、时长与资源形式集中呈现，
              帮助你在更短的时间里找到想看的内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["课程目录", "教学视频", "完整版", "第一课", "资源汇总"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full bg-background-50/10 text-background-200 text-xs font-label"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.id} className="md:col-span-3">
              <h3 className="font-heading font-semibold text-sm text-background-50">
                {section.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200/80 hover:text-primary-300 transition-colors font-body"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/70 font-label">
            © {new Date().getFullYear()} 秘密教学系列 · 课程目录与资源汇总
          </p>
          <p className="text-xs text-background-200/70 font-body max-w-xl leading-relaxed">
            本页为对系列内容的目录式整理，仅供快速定位参考，具体资源以官方发布为准。
          </p>
        </div>
      </div>
    </footer>
  );
}